export default "__VITE_ASSET__e8dffaba__"